import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { LiquidacionItemSchema, LiquidacionSchema, LiquidacionesPaginadasSchema, } from '@/data/dto/liquidacion';
export const liquidacionesApi = {
    async listar(filtros) {
        const res = await apiClient.get(ENDPOINTS.liquidaciones, {
            params: {
                tipo: filtros.tipo,
                estado: filtros.estado,
                personaId: filtros.personaId,
                pagina: filtros.pagina,
                porPagina: filtros.porPagina,
                rangoHastaDesde: filtros.rangoHastaDesde,
                rangoHastaHasta: filtros.rangoHastaHasta,
            },
        });
        return LiquidacionesPaginadasSchema.parse(res.data);
    },
    async ver(id) {
        const res = await apiClient.get(`${ENDPOINTS.liquidaciones}/${id}`);
        return LiquidacionSchema.parse(res.data);
    },
    async items(id) {
        const res = await apiClient.get(`${ENDPOINTS.liquidaciones}/${id}/items`);
        return z.object({ items: z.array(LiquidacionItemSchema) }).parse(res.data).items;
    },
    async generar(values) {
        const res = await apiClient.post(ENDPOINTS.liquidaciones, {
            tipo: values.tipo,
            personaId: values.personaId,
            rangoDesde: values.rangoDesde,
            rangoHasta: values.rangoHasta,
            observaciones: values.observaciones || null,
        });
        return LiquidacionSchema.parse(res.data);
    },
    async agregarAjuste(id, values) {
        const res = await apiClient.post(`${ENDPOINTS.liquidaciones}/${id}/ajustes`, {
            descripcion: values.descripcion,
            monto: values.monto,
            fechaReferencia: values.fechaReferencia || null,
        });
        return LiquidacionItemSchema.parse(res.data);
    },
    async aprobar(id) {
        const res = await apiClient.post(`${ENDPOINTS.liquidaciones}/${id}/aprobar`);
        return LiquidacionSchema.parse(res.data);
    },
    async marcarPagada(id, fechaPago) {
        const res = await apiClient.post(`${ENDPOINTS.liquidaciones}/${id}/marcar-pagada`, {
            fechaPago: fechaPago ?? null,
        });
        return LiquidacionSchema.parse(res.data);
    },
};
